export const stages = {
    STAGE_MAIL:1,
    STAGE_PASSWORD:2,
    STAGE_REGISTER:3,
    STAGE_CODE:4,
    STAGE_TYPE_SELECTION:5,
    STAGE_MY_ADDRESS:6,
    STAGE_BRANCH:7,
    STAGE_ADDRESSES:8,
    STAGE_NEWLOGIN:9,
    STAGE_TAKEAWAY:10,
    STAGE_FORGOTSTEP1:11,
    STAGE_ADD_ADDRESS:12,
    STAGE_CHOICE_BRANCH: 13,
    STAGE_FORGOT_PASSWORD: 14,
    STAGE_FORGOT_NEXT_PASSWORD: 15,
    STAGE_RESET_PASSWORD: 16,
  }